angular.module('unergie.main')
.filter('googleMapsUrl', () => {
    const GOOGLE_MAPS_URL_TEMPLATE = 'https://www.google.fr/maps/search/'
    const joinArray = function (val) { if (_.isArray(val)) { return val.join(' ') } return val }
    const replaceSpaceToPlus = function (val) { if (_.isString(val)) { return val.replace(/\s/g, '+') } return '' }

    return (address) => GOOGLE_MAPS_URL_TEMPLATE + replaceSpaceToPlus(joinArray(address))
})
